import axios from "axios";
import config from "../../settings";

export const authAPI = {
    getToken: (authorizationCode, thenCallback) => {
        //axios.get(`${config.baseIdpUrl}${config.token}`, { 
          axios.get(`${config.baseUrl}${config.token}${config.getAccessTokenCode}&${authorizationCode}` ,{
            headers: { 'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*'}
        })
            .then(res => {
                thenCallback(res.data);
            })
            .catch(err => {
                console.log(err);
                window.sessionStorage.removeItem('user');
                window.sessionStorage.removeItem('code');
                window.location.href = "/unauthorized";
            })
    }
}